import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchangeAlt, faTag } from '@fortawesome/pro-solid-svg-icons';
import { Nav, NavItem, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';

import FullSizeTab from 'bundles/project/components/full_size_tab';
import LeaseComps from 'bundles/project/components/property_comps/lease';
import SaleComps from 'bundles/project/components/property_comps/sale';
import { setQueryParameter, getTabQueryParam } from 'helpers/browser_helpers';

import './styles.scss';

const tabs = {
  saleComps: 'saleComps',
  leaseComps: 'leaseComps',
};

export const CompsTab = ({ coordinates }) => {
  const [tab, setTab] = useState(getTabQueryParam(tabs, 'compsTab'));

  function selectTab(activeTab) {
    setQueryParameter('compsTab', activeTab);
    setTab(activeTab);
  }

  return (
    <FullSizeTab className="project-comps-tab">
      <div className="panel panel-default">
        <Nav activeKey={tab} bsStyle="pills" className="muted" onSelect={selectTab}>
          <NavItem eventKey={tabs.saleComps}>
            <FontAwesomeIcon icon={faTag} size="lg" />
            Sale Comps
          </NavItem>
          <NavItem eventKey={tabs.leaseComps}>
            <FontAwesomeIcon icon={faExchangeAlt} size="lg" />
            Lease Comps
          </NavItem>
        </Nav>
        <Tab.Container
          activeKey={tab}
          id="project-comps-tab-subtabs"
          onSelect={() => { /* Tab.Container is weird */ }}
        >
          <Tab.Content animation={false} mountOnEnter unmountOnExit>
            <Tab.Pane eventKey={tabs.saleComps} key={tabs.saleComps}>
              <SaleComps coordinates={coordinates} />
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.leaseComps} key={tabs.leaseComps}>
              <LeaseComps coordinates={coordinates} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </FullSizeTab>
  );
};

CompsTab.propTypes = {
  coordinates: PropTypes.object
};

const mapStateToProps = (state) => {
  const { latitude, longitude } = state.project.researchProperty;
  let coordinates;
  if (latitude || longitude) {
    coordinates = { latitude, longitude };
  }

  return {
    coordinates
  };
};

export default connect(mapStateToProps)(CompsTab);
